module.exports = __webpack_public_path__ + "520cc3a0a0008c8002afa1cc245724a4.png";